// All Slinger X SKUs — standalone and add-on groups/bundles, both now on the grouped 3-bundle-children shape.
// Used for the PDP accordion as well as cart/checkout/order-history/PDF surfaces.
export const SLINGER_X_SKUS: string[] = 
[
  'SLINGER-X-GROUP', 
  'SLINGER-X-BUNDLE',
  'SLINGER-X-BUNDLE-LEFT', 
  'SLINGER-X-BUNDLE-RIGHT', 

  'SLINGER-X-ADD-ON-GROUP',
  'SLINGER-X-ADD-ON-BUNDLE',

  'ML-SLINGER-X-GROUP', 
  'ML-SLINGER-X-BUNDLE',
  'ML-SLINGER-X-BUNDLE-LEFT', 
  'ML-SLINGER-X-BUNDLE-RIGHT',


  'ML-SLINGER-X-ADD-ON-GROUP',
  'ML-SLINGER-X-ADD-ON-BUNDLE',

]

// The individual left/right side bundle SKUs — used in bundle-option.vue to detect when getSideOptionsForSlingerX should run.
export const SLINGER_X_SIDE_SKUS: string[] =
[
  'SLINGER-X-BUNDLE-LEFT',
  'SLINGER-X-BUNDLE-RIGHT',

  'ML-SLINGER-X-BUNDLE-LEFT',
  'ML-SLINGER-X-BUNDLE-RIGHT',
]

// The main/lead bundle SKUs (standalone + add-on) — the ones that carry the real rack config and
// should be treated as the lead row in cart/order-history/PDF (Cave's MAIN_CAVE_BUNDLE equivalent).
export const SLINGER_X_BUNDLE_SKUS: string[] =
[
  'SLINGER-X-BUNDLE',
  'SLINGER-X-ADD-ON-BUNDLE',

  'ML-SLINGER-X-BUNDLE',
  'ML-SLINGER-X-ADD-ON-BUNDLE',
]

// The RML Add-on's top-level group SKU — the only Slinger X variant that surfaces a dedicated
// Accessories footer (RM Add-on and both standalone variants rely on the Left/Right Side accordion instead).
export const ML_SLINGER_X_ADDON_GROUP_SKU = 'ML-SLINGER-X-ADD-ON-GROUP'